import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { MODULE_PATHS, MODULE_PATH_LEGACY_REDIRECTS } from '../../data/numerologyCourse';
import NumerologyLearnPage from '../../pages/numerology/NumerologyLearnPage';
import NumerologyModulePage from '../../pages/numerology/NumerologyModulePage';

/** Legacy study slugs merged or renamed in the course structure. */
const STUDY_SLUG_REDIRECTS = {
  'numerology-101': 'm1-what-is-numerology',
  'life-path-number-meanings': 'life-path-number-calculator',
  'your-expression-number': 'your-name-numerology',
  'personality-decoder': 'how-to-read-your-numerology-chart',
  'annual-numerology-forecast': 'numerology-timing-cycles',
  'monthly-numerology-report': 'numerology-timing-cycles',
  'daily-numerology-forecast': 'numerology-timing-cycles',
  'numerology-reading-2026': 'numerology-timing-cycles',
  'what-are-angel-numbers': 'appendix-angel-numbers',
  'numerology-compatibility-guide': 'how-to-read-your-numerology-chart',
  'deluxe-numerology-report': 'your-personal-numerology-report',
  /** Canonical lesson aliases → existing deep content */
  'm2-life-path-meanings-1-9': 'numerology-numbers-1-9',
  'm1-core-numbers-overview': 'your-core-numbers',
};

export default function NumerologyStudySlugPage() {
  const { slug } = useParams();
  /** Legacy index slug — course home lists all modules. */
  if (slug === 'numerology-articles') {
    return <Navigate to="/numerology/study" replace />;
  }
  const target = STUDY_SLUG_REDIRECTS[slug];
  if (target) {
    return <Navigate to={`/numerology/study/${target}`} replace />;
  }
  const legacyModule = slug && MODULE_PATH_LEGACY_REDIRECTS[slug];
  if (legacyModule) {
    return <Navigate to={`/numerology/study/${legacyModule}`} replace />;
  }
  if (slug && MODULE_PATHS.has(slug)) {
    return <NumerologyModulePage />;
  }
  return <NumerologyLearnPage />;
}
